import { useState } from 'react';
import Modal from './Modal.jsx';
import { apiChangePassword } from '../api.js';

export default function ChangePassword({ onClose }) {
  const [oldPassword, setOld] = useState('');
  const [newPassword, setNew] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const inputCls = 'w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500';
  const Field = ({ label, value, onChange }) => (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
      <input type="password" value={value} onChange={onChange} className={inputCls} />
    </div>
  );

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPassword !== confirm) { setError('两次输入的密码不一致'); return; }
    setSaving(true);
    try {
      await apiChangePassword({ oldPassword, newPassword });
      alert('密码修改成功');
      onClose();
    } catch (err) {
      setError(err?.status === 401 ? '当前密码不正确' : '修改失败，请稍后重试');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal title="修改密码" onClose={onClose} maxWidth="max-w-md">
      <form onSubmit={submit} className="p-6 space-y-4">
        <Field label="当前密码" value={oldPassword} onChange={(e) => setOld(e.target.value)} />
        <Field label="新密码" value={newPassword} onChange={(e) => setNew(e.target.value)} />
        <Field label="确认新密码" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
        {error && <p className="text-sm text-red-600">{error}</p>}
        <div className="pt-4 flex justify-end gap-3">
          <button type="button" onClick={onClose} className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">取消</button>
          <button type="submit" disabled={saving} className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-60">{saving ? '保存中…' : '保存'}</button>
        </div>
      </form>
    </Modal>
  );
}
